import React from 'react';
import { Button, Dropdown, InlineErrorMessage, Typography } from '@dcl/ui';
import { ButtonKind, ButtonColor } from '@dcl/ui/dist/elements/Button';
import { ExpandableContentProps } from '../types';
import { filterFn } from '../helpers/filterProduct';
import { CLEAR_BUTTON_LABEL } from '../helpers/constants';

export const ExpandableContent = (props: ExpandableContentProps) => {
  const {
    showError,
    handleFilterValueChange,
    handleClearButtonClick,
    handleValueChange,
    productLink,
    handleSubmit,
    submitButtonText,
    hideButtonText,
    showButtonText,
    headerProps,
    getClassName,
    dropdownLabel,
    dropdownProductList,
    browseLabel,
  } = props;

  const paddingZero = getClassName({ descendantName: 'paddingZero' });
  const headingContainer = getClassName({ descendantName: 'headingContainer' });
  const dropdownContainer = getClassName({
    descendantName: 'dropdownContainer',
  });
  const submitButton = getClassName({ descendantName: 'submitButton' });
  const showAllContainer = getClassName({ descendantName: 'showAllContainer' });
  const visibleErrorDiv = getClassName({ descendantName: 'visibleError' });
  const hiddenErrorDiv = getClassName({ descendantName: 'hiddenError' });

  return (
    <div className={getClassName({ descendantName: 'section' })}>
      <div
        className={getClassName({
          descendantName: 'alignVerticallyCenter',
        })}
      >
        <div className={`${paddingZero} ${headingContainer}`}>
          <Typography className={getClassName({ descendantName: 'title' })}>
            {browseLabel}
          </Typography>
        </div>

        <div className={getClassName({ descendantName: 'wrapper' })}>
          <div
            className={getClassName({
              descendantName: 'safrronDropdownWrapper',
            })}
          >
            <div
              className={getClassName({
                descendantName: 'typographyContainer',
              })}
            >
              <label htmlFor="filter-input-id-4">
                <Typography
                  className={getClassName({
                    descendantName: 'dropdownLabel',
                  })}
                >
                  {dropdownLabel}
                </Typography>
              </label>
            </div>

            <div className={`${paddingZero} ${dropdownContainer}`}>
              <div
                id="ProductDropDown"
                className={showError ? visibleErrorDiv : hiddenErrorDiv}
              >
                <Dropdown
                  filterFunction={filterFn}
                  typeaheadMode
                  onFilterValueChanged={(value) =>
                    handleFilterValueChange(value as string)
                  }
                  clearButtonLabel={CLEAR_BUTTON_LABEL}
                  onClearButtonClick={handleClearButtonClick}
                  maxVisibleItems={5}
                  block={true}
                  items={dropdownProductList}
                  labeledBy={dropdownLabel}
                  placeholder=""
                  onValueChanged={(value) => handleValueChange(value as string)}
                  className={getClassName({
                    descendantName: 'customDropdownStyle',
                  })}
                  removeAutoFocus
                />
              </div>
              <InlineErrorMessage
                id="validationError"
                errorMessage={dropdownLabel}
                className={getClassName({
                  descendantName: 'error',
                  modifiers: showError ? 'visible' : 'hidden',
                })}
              />
            </div>
          </div>

          <div className={`${submitButton}`}>
            {productLink !== '' ? (
              <Button
                kind={ButtonKind.LINK}
                color={ButtonColor.PRIMARY}
                href={productLink}
                newWindow={false}
                disabled={false}
                data-testid="ProductSelection-submitButton"
              >
                {submitButtonText}
              </Button>
            ) : (
              <Button
                kind={ButtonKind.BUTTON}
                color={ButtonColor.PRIMARY}
                href={productLink}
                newWindow={false}
                disabled={false}
                onClick={handleSubmit}
                data-testid="ProductSelection-submitButton"
              >
                {submitButtonText}
              </Button>
            )}
          </div>

          <div className={`${showAllContainer}`}>
            <span className={getClassName({ descendantName: 'border' })}></span>
            <button
              aria-label={
                headerProps.isExpanded ? hideButtonText : showButtonText
              }
              aria-expanded={headerProps.isExpanded ? 'true' : 'false'}
              aria-controls="newProductsContent"
              onClick={headerProps.onClick}
              className={getClassName({
                descendantName: 'showallProductsButton',
              })}
            >
              {headerProps.isExpanded ? hideButtonText : showButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
